import axios from "axios";
import { toast } from "react-toastify";
import './RoHandoverModal.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const RoHandoverModal = ({ officers, showRoHandoverModal, setShowRoHandoverModal, selectedNewRo, setSelectedNewRo, roOfficerToDisable, setRoOfficerToDisable, handleToggleStatus }) => {
    if (!showRoHandoverModal) return null;

    const otherRoOfficers = officers.filter(
        (o) => o.designation === "RO" && o.officerId !== roOfficerToDisable.officerId
    );

    console.log({ officers, selectedNewRo, roOfficerToDisable });

    const handleConfirmRoHandover = async () => {
        if (!selectedNewRo || !roOfficerToDisable) {
            toast.warn("Please select the current RO or new RO officer");
            return;
        }

        // 1. Call your API to handover RO responsibilities
        try {
            // 2. Now toggle RO's status normally
            handleToggleStatus(
                roOfficerToDisable.officerId,
                roOfficerToDisable.markStatus,
                selectedNewRo
            );
        } catch (err) {
            toast.error("Failed to hand over RO role");
        }
        finally{
            setShowRoHandoverModal(false);
            setSelectedNewRo("");
            setRoOfficerToDisable(null);
        }
    };


    return (
        <div className="handover-modal-backdrop">
            <div className="handover-modal">
                <h4>Hand Over RO Responsibilities</h4>

                <p>
                    Select another RO officer to hand over responsibilities before disabling:
                    <strong> {roOfficerToDisable?.name}</strong>
                </p>

                <select
                    className="form-control"
                    value={selectedNewRo}
                    onChange={(e) => setSelectedNewRo(e.target.value)}
                >
                    <option value="">Select RO Officer</option>
                    {otherRoOfficers.map((ro) => (
                        <option key={ro.officerId} value={ro.officerId}>
                            {ro.name} ({ro.employeeId})
                        </option>
                    ))}
                </select>

                <div className="modal-actions">
                    <button className="btn btn-secondary" onClick={() => {
                        setShowRoHandoverModal(false);
                        setSelectedNewRo("");
                    }}>
                        Cancel
                    </button>

                    <button
                        className="btn btn-primary"
                        disabled={!selectedNewRo}
                        onClick={handleConfirmRoHandover}
                    >
                        Confirm & Disable
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RoHandoverModal;
